var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBanner = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0.515 -33.819 98.041 147.375",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.824-33.504h97.412v114.4L49.53 112.999.824 80.896v-114.4Z",
  fill: "#DE554B",
  stroke: "#514A92",
  strokeWidth: 0.588
})));
export { SvgBanner as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2aWV3Qm94PSIwLjUxNSAtMzMuODE5IDk4LjA0MSAxNDcuMzc1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0gMC44MjQgLTMzLjUwNCBMIDk4LjIzNiAtMzMuNTA0IEwgOTguMjM2IDgwLjg5NiBMIDQ5LjUzIDExMi45OTkgTCAwLjgyNCA4MC44OTYgTCAwLjgyNCAtMzMuNTA0IFoiIGZpbGw9IiNERTU1NEIiIHN0cm9rZT0iIzUxNEE5MiIgc3Ryb2tlLXdpZHRoPSIwLjU4ODI5OSIgc3R5bGU9IiIvPgo8L3N2Zz4=";